import { postMainApi, putMainApi, deleteMainApi, getMainApi, getSecureAccountsApi } from "@Shared/utils/ajax";
import { isEmpty, omitBy, pickBy } from "lodash";

/**
 * Get a signed url for uploading to S3 bucket
 * @param {string} fileName The name of the file to upload
 */
export const getFilogixSignedURL = async fileName => {
  const endpoint = "/filogix/import/signed-s3-url";
  return getMainApi({
    fileName
  }, endpoint);
};
export const notifyImport = async (fileName, documentId) => {
  const endpoint = "/filogix/import/notify";
  return postMainApi({
    fileName,
    documentId
  }, endpoint);
};
export const getReferrers = async () => {
  return getMainApi({}, "/client/referrer");
};
export const getSchema = async (isBrokerage = false) => {
  if (isBrokerage) return getMainApi({}, "/brokerage/customize/application");
  return getSecureAccountsApi({}, "/customize/application");
};

/**
 * Send post request to begin application on client behalf
 */
export const createApp = async data => {
  return postMainApi(omitBy(data, isEmpty), "/client");
};
export const getClientsByAgent = async (params = {}) => {
  const endpoint = "/client";
  if (params.searchString) params.searchString = encodeURIComponent(params.searchString);
  return getMainApi(pickBy(params, val => val != null && val !== ""), endpoint);
};
export const getClientApplicationsInfo = async (clientUsername, agentUsername) => {
  return getMainApi({
    agentUsername
  }, `/client/${clientUsername}/application-info`);
};

/**
 * Retrieves board data
 * @param {Boolean} force Force fetch the data from backend
 */
export const getBoards = async () => {
  return getMainApi({}, "/client/board");
};

/**
 * Send Request to the backend for adding a new client profile.
 */

export const addClientProfile = async (data, boardId) => {
  if (!data.value) data.value = 0;
  return postMainApi(data, `/client/profile?boardId=${boardId}`);
};
export const createAdditionalApplication = async (data, clientUsername, agentUsername, clientProfileId) => {
  return postMainApi(omitBy(data, val => val == null), `/client/${clientUsername}?${$.param(omitBy({
    agentUsername,
    clientProfileId
  }, isEmpty))}`);
};
export const putConsent = async (status, clientUsername, applicationId, date) => {
  return putMainApi({
    consentStatus: status,
    date
  }, `/client/${clientUsername}/application/${applicationId}/consent`);
};
export const starClient = async clientUsername => {
  return postMainApi({}, `/client/${clientUsername}/star`);
};
export const deleteApplication = async (clientUsername, applicationId) => {
  return deleteMainApi(`/client/${clientUsername}/application/${applicationId}`);
};
export const importApplications = async (expertDealId, startDate, endDate, statusList) => {
  return postMainApi({
    expertDealId,
    startDate,
    endDate,
    statusList
  }, "/filogix/import");
};
export const verifyImportApplications = async (code, expertDealId, startDate, endDate) => {
  return postMainApi({
    code,
    expertDealId,
    startDate,
    endDate
  }, "/filogix/import/verify");
};